<template>
	<div class="favorites-container">
		<div
			class="wrapper-btn-back"
			:style="`background-color:${globalColors.primary}`"
		>
			<button 
				class="profile-orders-back"
				@click="$emit('close-modal')">
				<img 
					src="/static/img/arrow-back.svg" 
					alt="ir hacia atras"
					class="arrow-back">
			</button>
			<p
				class="bold txt-center title-btn"
			>MIS FAVORITOS</p>
		</div>
		<div
			class="favorites-title mb-2 title-bold uppercase"
			:style="`color:${globalColors.primary}`"
		>MIS favoritos</div>
		<section class="favotite-table">
			<std-table
				:columns="headers"
				:rows="rows"
			>
				<template slot-scope="{ row }">
					<td>
						<div class="product-info" @click="goTo(row)">
							<div class="img-container">
								<img :src="row.urlImage" alt="imagen del producto" class="img-product">
							</div>
							<div>
								<p><b><i>{{row.name}}</i></b></p>
								<p>{{row.description}}</p>
							</div>
						</div>
					</td>
					<td class="txt-center">{{ row.priceDiscount }}</td>
					<td class="d-flex align-center justify-center">
						<button
							class="btn-close"
							:style="`border: 0.1rem solid ${globalColors.titulo}`"
							@click="notFavorite(row)"
						>X</button>
					</td>
				</template>
			</std-table>
		</section>
	</div>
</template>
<script>
import stdTable from '@/components/tableStd';

function created() {
	this.loadData();
}

async function loadData() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const url = 'products/favorites?favorite=true';
	({ data: this.rows } = await this.$httpQtc.get(url, { headers }));
}

async function notFavorite({ id, name }) {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const url = `products/favorite/${id}`;
	const body = { isFavorite: false };
	await this.$httpQtc.post(url, body, { headers });
	this.$message({
		message: `Producto "${name}" ya no es favorito`,
		showClose: true,
		type: 'info',
	});
	this.loadData();
}

function goTo(product) {
	this.$router.push({ name: 'products', params: { id: product.slug || product.id } });
}

function data() {
	return {
		headers: [
			{ title: 'PRODUCTO', value: 'product' },
			{ title: 'PRECIO', value: 'priceDiscount', width: '0*' },
			{ title: 'ACCIONES', value: 'actions', width: '0*' },
		],
		rows: [],
		token: this.$store.state.token,
	};
}

export default {
	name: 'list',
	components: {
		stdTable,
	},
	created,
	data,
	methods: {
		goTo,
		loadData,
		notFavorite,
	},
};
</script>
<style lang="scss" scoped>
	.favorites-container {
		padding: 1rem 0 0 4rem;

		@media screen and (max-width: 768px) {
			padding: 1rem 1rem 0;
		}
	}

	.favorites-title {
		font-size: size(maxsmall);

		@media screen and (max-width: 768px) {
			display: none;
		}
	}

	.title-bold {
		font-family: font(avenirBold) !important;
		font-size: size(normal);
	}

	.favotite-table {
		font-size: size(medium);
	}

	.btn-close {
		border-radius: 50%;
		height: 2.5rem;
		width: 2.5rem;
	}

	.img-container {
		height: 4.2rem;
		width: 4.2rem;
	}

	.img-product {
		height: 100%;
		object-fit: cover;
		width: 100%;
	}

	.product-info {
		align-items: center;
		cursor: pointer;
		display: grid;
		grid-column-gap: 1rem;
		grid-template-columns: 0.25fr 2fr;
	}

	.wrapper-btn-back {
		display: none;
		margin-bottom: 3.6rem;
		padding: 0.1rem 1rem;
		position: relative;

		@media screen and (max-width: 768px) {
			display: block;
		}
	}

	.arrow-back {
		height: 1.5rem;
	}

	.title-btn {
		color: color(white);
		font-size: size(small);
	}

	.profile-orders-back {
		background: none;
		border: none;
		outline: none;
		position: absolute;
		top: 33%;
	}
</style>




// WEBPACK FOOTER //
// list.vue?655afa79